import { replaceWithHomeRoute } from './publicRoutes';
import { hasCommunicationPreferencesQuery } from './communicationPreferencesDeepLink';
import { clearSeoOpportunityIntent, readPendingSeoOpportunityId } from './seoOpportunityDeepLink';

const MODULE_QUERY_VALUE = 'auditor';

export function hasAuditorModuleQuery(): boolean {
  return typeof window !== 'undefined'
    && new URLSearchParams(window.location.search).get('module') === MODULE_QUERY_VALUE;
}

function removeAuditorModuleQuery(): void {
  if (!hasAuditorModuleQuery()) return;
  const url = new URL(window.location.href);
  url.searchParams.delete('module');
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}

export function replaceMagicLinkWithHomeRoutePreservingAuditorModule(): void {
  const shouldOpenAuditor = hasAuditorModuleQuery();
  const shouldOpenPreferences = hasCommunicationPreferencesQuery();
  const seoOpportunityId = shouldOpenAuditor || shouldOpenPreferences ? null : readPendingSeoOpportunityId();
  replaceWithHomeRoute();
  clearSeoOpportunityIntent();
  if (!shouldOpenAuditor && !shouldOpenPreferences && !seoOpportunityId) return;
  const url = new URL(window.location.href);
  if (seoOpportunityId) url.searchParams.set('seoOpportunity', seoOpportunityId);
  else if (shouldOpenPreferences) url.searchParams.set('settings', 'privacy');
  else url.searchParams.set('module', MODULE_QUERY_VALUE);
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}

export function hasPendingAuditorModuleIntent(): boolean {
  return hasAuditorModuleQuery();
}

export function consumeAuditorModuleIntent(): void {
  removeAuditorModuleQuery();
}
